// Утилиты для работы с высотой viewport на мобильных устройствах

/**
 * Получает корректную высоту viewport с учетом мобильных браузеров
 */
export const getViewportHeight = (): number => {
  return window.innerHeight;
};

/**
 * Получает высоту viewport в пикселях как CSS переменную
 */
export const getViewportHeightCSS = (): string => {
  return `${getViewportHeight()}px`;
};

/**
 * Обновляет CSS переменные для высоты viewport
 */
export const updateViewportHeightCSS = (): void => {
  const root = document.documentElement;
  const vh = getViewportHeight();
  // Кладём 1% от высоты viewport в пикселях,
  // чтобы calc(var(--vh) * 100) давал реальную высоту экрана
  const oneVhInPx = vh * 0.01;

  root.style.setProperty('--vh', `${oneVhInPx}px`);
  root.style.setProperty('--dvh', `${oneVhInPx}px`);
  root.style.setProperty('--lvh', `${oneVhInPx}px`);
  root.style.setProperty('--svh', `${oneVhInPx}px`);
};

/**
 * Инициализирует слушатели событий для обновления высоты viewport
 */
export const initViewportHeightListeners = (): (() => void) => {
  const updateHeight = () => {
    updateViewportHeightCSS();
  };

  // Обновляем при изменении размера окна
  window.addEventListener('resize', updateHeight);

  // Обновляем при изменении ориентации
  window.addEventListener('orientationchange', () => {
    setTimeout(updateHeight, 100);
  });

  // Обновляем при фокусе (для случаев когда браузер показывает/скрывает UI)
  window.addEventListener('focus', updateHeight);
  window.addEventListener('blur', updateHeight);

  // Инициализируем сразу
  updateHeight();

  // Возвращаем функцию для очистки
  return () => {
    window.removeEventListener('resize', updateHeight);
    window.removeEventListener('orientationchange', updateHeight);
    window.removeEventListener('focus', updateHeight);
    window.removeEventListener('blur', updateHeight);
  };
};
